// IE and Safari don't support the EventTarget constructor
import EventTarget from "@ungap/event-target";

// If you are thinking about using this, please consider carefully whether you should. It exists to
// work around a specific architectural failure in Engage and should not be considered a good
// general approach to communication between components.
export const engageEventBus = new EventTarget();
